import { PhoneInput } from '@velocity/ui';
import React from 'react';
import FormFieldShell, { FormFieldShellProps } from './form-field-shell';

export interface FormPhoneFieldProps extends FormFieldShellProps {
  /** Full international number, e.g. `+4940471040` */
  value?: string | null;
  onChange: (value: string) => void;
  onBlur?: () => void;
  /** ISO country that is preselected when the field is empty */
  defaultCountryCode?: string;
  dataTestId?: string;
}

/*
 * Velocity `FormField` + `PhoneInput` (Figma: formkit/phone-input) - flag
 * dropdown with dial code, 40px high. Controlled, meant to be used with
 * react-hook-form's `Controller`; the form value is the full international
 * number so validation stays in the yup schema (libphonenumber-js).
 */
const FormPhoneField: React.FC<FormPhoneFieldProps> = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  defaultCountryCode = 'DE',
  hideLabel,
  errorMessage,
  hint,
  tooltip,
  required,
  disabled,
  readOnly,
  dataTestId,
  className,
}) => (
  <FormFieldShell
    {...{
      name,
      label,
      hideLabel,
      errorMessage,
      hint,
      tooltip,
      required,
      disabled,
      readOnly,
      className,
    }}
  >
    <PhoneInput
      name={name}
      value={value ?? ''}
      defaultCountryCode={defaultCountryCode}
      onChange={(event) => onChange(event.target.value)}
      onBlur={onBlur}
      inputProps={{
        'data-testid': dataTestId ?? `input-field-${name}`,
        inputMode: 'tel',
      }}
    />
  </FormFieldShell>
);

export default FormPhoneField;
